'use es6';

export var INVALID_TZ_GUESS = 'invalid-tz-guess';